import React from 'react';
import PropTypes from 'prop-types';

import RegisteredInfoProvidersSelect from './RegisteredInfoProvidersSelect';

// Adapter for GenericSearchBar inputs: maps the controlled selection to the `infoProvider` filter
// key. Clearing the select omits the filter instead of sending null.
const RegisteredInfoProvidersInput = ({ handleInputChange, values }) => (
  <RegisteredInfoProvidersSelect
    isClearable
    onChange={(value) => handleInputChange({ infoProvider: value || undefined })}
    value={values?.infoProvider || ''}
  />
);

RegisteredInfoProvidersInput.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  values: PropTypes.object
};

export default RegisteredInfoProvidersInput;
